var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"33":1,"71":1,"363":1,"467":1,"529":1,"587":1,"605":1,"637":1,"649":1,"673":1,"697":1,"771":1,"821":1,"1083":1,"1111":1,"1313":1,"1343":1,"1486":1,"1763":1,"1775":1,"1778":1,"1867":1,"1874":1,"1953":1,"2247":1,"2513":1,"2599":1,"2663":1,"2739":1,"2809":1,"2817":1,"2857":1,"2917":1,"2938":1,"2980":1,"3030":1,"3080":1,"3347":1,"3421":1,"3527":1,"3655":1,"3853":1,"3938":1,"3979":1,"4019":1,"4053":1,"4153":1,"4543":1,"4709":1,"4717":1,"4902":1,"5009":1,"5259":1,"5283":1,"5357":1,"5411":1,"5467":1,"5514":1,"5903":1,"6182":1,"6335":1,"6435":1,"6489":1,"6733":1,"6753":1,"6883":1,"6891":1,"7181":1,"7267":1,"7436":1,"7653":1,"7779":1,"7785":1,"8194":1,"8198":1,"8363":1,"8418":1,"8455":1,"8475":1,"8483":1,"8509":1,"8563":1,"8565":1,"8605":1,"8625":1,"8677":1,"8683":1,"8819":1,"8883":1,"8915":1,"9077":1,"9114":1,"9167":1,"9186":1,"9254":1,"9357":1,"9390":1,"9452":1,"9469":1,"9507":1,"9524":1,"9554":1,"9567":1,"9615":1,"9801":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr